import React from "react"
import Index from "./Index"
import Forbidden from "./Forbidden"
import { useUser } from "../contexts/UserContext"

interface ViewProps {
    component: React.FC;
    module: string;
}

const ViewWrapper: React.FC<ViewProps> = ({ component, module }) => {
  const { user } = useUser()
  
  // Basic permission check
  const views = user.permissions.views || []
  const hasPermission = views.length === 0 || views.join().toLowerCase().includes(module.toLowerCase())

  const content = hasPermission ? component : Forbidden

  return <Index content={content} module={module} />
}

export default ViewWrapper
